import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import { isEmpty } from "lodash";
import InfoTag from "pages/echeck/components/InfoTag";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import { ResponsiveHeader } from "pages/_components/header";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { actions as transferActions } from "reducers/transfers";
import * as i18n from "util/i18n";
import InternalTransferSummaryBody from "./Internals/components/Summary";
import OtherTransferSummaryBody from "./Others/components/Summary";

const TransferSummaryPage = () => {
    const { type } = useParams();

    const transfers = useSelector((state) => state.transfers);
    const transferData = transfers[`${type}TransferData`];
    const { transferTicket } = useSelector((state) => state.transfers);
    useConfirmTransaction(transferData, transferTicket, `transfers/${type}`);
    const isInternal = type === "internal";
    const isOther = type === "other";
    const isProgrammed = !isEmpty(transferData?.scheduler);
    const willCancel = transferData?.cancelTransaction;

    const selectAction = {
        internal: transferActions.sendInternalTransfer,
        other: transferActions.sendOtherTransfer,
    };

    const selectActivity = {
        internal: "generate.transfer",
        other: "generate.transfer.third.party",
    };

    return (
        <>
            <Notification scopeToShow="TransferSummaryPage" />
            <ResponsiveHeader
                id={willCancel ? "payments.cancel.title" : `transfer.${type}.summary.title`}
                infoComponents={
                    isProgrammed ? (
                        <InfoTag
                            tagBackground="programmed"
                            tagClass="ml-5 font-weight-bold"
                            message={i18n.get("scheduler.tag")}
                        />
                    ) : null
                }
            />
            <MainContainer>
                <I18n id="transfer.summary.confirm" component="h2" />
                {isInternal && (
                    <InternalTransferSummaryBody
                        debitAccountId={transferData.debitAccount}
                        creditAccountId={transferData.creditAccount}
                        amount={transferData.amount}
                        reference={transferData.reference}
                        reason={transferData.reason}
                        sendEmail={transferData.sendEmail}
                        email={transferData.email}
                        emailText={transferData.emailText}
                        scheduler={transferData.scheduler}
                    />
                )}
                {isOther && (
                    <OtherTransferSummaryBody
                        debitAccountId={transferData.debitAccount}
                        creditCbu={transferData.creditCbu}
                        transferKind={transferData.transferKind}
                        amount={transferData.amount}
                        reasonCode={transferData.reasonCode}
                        reference={transferData.reference}
                        reason={transferData.reason}
                        creditCuit={transferData.creditCuit}
                        nameRecipient={transferData.nameRecipient}
                        beneficiary={transferData.beneficiary}
                        frequentDestination={transferData.frequentDestination}
                        sendEmail={transferData.sendEmail}
                        email={transferData.email}
                        emailText={transferData.emailText}
                        scheduler={transferData.scheduler}
                    />
                )}
                <GeneralCredentialForm
                    transactionData={transferData}
                    action={willCancel ? transferActions.cancelTransfer : selectAction[type]}
                    isCancel={willCancel}
                    idActivity={selectActivity[type]}
                    hideIndications
                />
            </MainContainer>
        </>
    );
};

export default TransferSummaryPage;
